import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const FALLBACK_CONFIG = {
  enabled: true,
  title: "Support",
  links: [
    { label: "About Us", to: "/about" },
    { label: "Contact Us", to: "/contact" },
    { label: "Return Policy", to: "/returns" },
    { label: "Shipping Policy", to: "/shipping" },
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Terms of Service", to: "/terms" },
  ],
  note: "Need help with your order? Reach support from Contact Us.",
};

const isExternal = (url) => /^https?:\/\//i.test(String(url || ""));

export default function JsonFooter() {
  const [config, setConfig] = useState(FALLBACK_CONFIG);

  useEffect(() => {
    let mounted = true;
    fetch("/assets/screens/footer.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        if (!mounted || !json || typeof json !== "object") return;
        setConfig({
          ...FALLBACK_CONFIG,
          ...json,
          links: Array.isArray(json.links) ? json.links : FALLBACK_CONFIG.links,
        });
      })
      .catch(() => {
        // keep fallback config
      });
    return () => {
      mounted = false;
    };
  }, []);

  const links = useMemo(() => {
    return (config.links || [])
      .map((item) => ({
        label: String(item?.label || "").trim(),
        to: String(item?.to || "").trim(),
      }))
      .filter((item) => item.label && item.to);
  }, [config.links]);

  if (!config.enabled) return null;

  return (
    <footer className="lfx-json-footer">
      <div className="lfx-json-footer-inner">
        <h3 className="lfx-json-footer-title">{config.title || "Support"}</h3>
        <nav className="lfx-json-footer-links" aria-label="Support links">
          {links.map((item) =>
            isExternal(item.to) ? (
              <a key={item.to} href={item.to} target="_blank" rel="noreferrer" className="lfx-json-footer-link">
                {item.label}
              </a>
            ) : (
              <Link key={item.to} to={item.to} className="lfx-json-footer-link">
                {item.label}
              </Link>
            )
          )}
        </nav>
        {config.note ? <p className="lfx-json-footer-note">{config.note}</p> : null}
      </div>
    </footer>
  );
}
